import { render, staticRenderFns } from "./WarehouseDetail.vue?vue&type=template&id=2bbd04f0&scoped=true"
import script from "./WarehouseDetail.vue?vue&type=script&lang=js"
export * from "./WarehouseDetail.vue?vue&type=script&lang=js"
import style0 from "./WarehouseDetail.vue?vue&type=style&index=0&id=2bbd04f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbd04f0",
  null
  
)

export default component.exports